import { useEffect, useRef } from 'react';
import s from './PurchaseCloseGuard.module.css';

export function PurchaseCloseGuard({ detail, error, saveDisabled, saving, onSave, onDiscard, onContinue }: {
  detail: string;
  error?: string;
  saveDisabled: boolean;
  saving: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onContinue: () => void;
}) {
  const continueButton = useRef<HTMLButtonElement>(null);

  useEffect(() => { continueButton.current?.focus(); }, []);

  return <div className={s.backdrop} onMouseDown={(event) => { if (event.target === event.currentTarget && !saving) onContinue(); }}>
    <section className={s.sheet} role="dialog" aria-modal="true" aria-labelledby="purchase-close-title" aria-describedby="purchase-close-detail">
      <div className={s.head}>
        <h2 id="purchase-close-title">这张采购单还没保存</h2>
        <p id="purchase-close-detail">{detail}</p>
      </div>
      <button type="button" className={s.action} disabled={saveDisabled || saving} onClick={onSave}>{saving ? '正在保存…' : '存为草稿并退出'}</button>
      {error && <p className={s.error} role="alert">{error}</p>}
      {saveDisabled && !saving && <p className={s.hint}>请补齐必填信息后再存草稿；也可以放弃修改。</p>}
      <button type="button" className={`${s.action} ${s.danger}`} disabled={saving} onClick={onDiscard}>放弃修改</button>
      <button ref={continueButton} type="button" className={`${s.action} ${s.cancel}`} disabled={saving} onClick={onContinue}>继续编辑</button>
    </section>
  </div>;
}
